import {Routes, Route} from 'react-router-dom'
import {Login} from './Login'
import {VerifyOTP} from './VerifyOTP'

export const Authentication = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify-otp/*" element={<VerifyOTP />} />
      <Route path="/verify-otp/:mail" element={<VerifyOTP />} />
      <Route path="/verify-otp/:mail/:auth" element={<VerifyOTP />} />
    </Routes>
  )
}
